<div theme>
    <button mat-button [ngClass]="currentDisplayLanguage === 'ar' ? 'arabic-float' : ''" class="toolbar-icon-button dialog-closeicon" (click)="onCancel()">
        <mat-icon class="material-icons dialog-closeicon">
            close
        </mat-icon>
    </button>

    <div theme class="session-expired-container">
        <div fxLayout="column" fxLayoutAlign="start start" 
        [ngClass]="currentDisplayLanguage === 'ar' ? 'arabic-direction' : ''">
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
                <i class="fas fa-triangle-exclamation session-expired-clock"></i>
                <p class="error-title-text" cdkFocusInitial>Discard Changes ?</p>
            </div>

            <p class="error-message-text">You have unsaved changes. Are you sure you want to leave?</p>
        </div>

        <div fxLayout="row" fxLayoutAlign="end center" class="dialog-btn-wrapper">
            <button mat-button class="login-btn" (click)="keepEdit()">Keep Editing</button>
            <button mat-button class="discard-btn" (click)="discard()">Discard</button>
        </div>
    </div>
</div>